import React from "react";
import CategoryCard from "./CategoryCard";

const GridCard = ({ tickets = [] }) => {

    const categories = tickets.reduce((acc, ticket) => {
        if (!acc[ticket.category]) acc[ticket.category] = [];
        acc[ticket.category].push(ticket);
        return acc;
    }, {});

    return (
        <div className="flex-1 outline-none space-y-6">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
               {Object.entries(categories).map(([categoryName, tickets]) => (
                    <div key={categoryName} className="opacity-100 transform-none">
                        <CategoryCard 
                            category={categoryName} 
                            tickets={tickets}
                        />
                    </div>
                ))}
            </div>
        </div>
    )
};
export default GridCard;